// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import './utils/initComponent';
import App from './App';
// import router from './router';
import axios from 'axios';
import dataConfig from '@/dataConfig';
import { gotoApp } from '@/utils/share';
import {TAnalytics} from './utils/tanalytics';
import MtaH5 from 'mta-h5-analysis';

Vue.config.productionTip = false;
// 注册全局方法，截流模板的操作
Vue.prototype.$actMode = 'production';
Vue.prototype.$axios = axios;
Vue.prototype.$gotoApp = gotoApp;
Vue.prototype.$Tanalytics = TAnalytics;
const { pcHtmlData, h5HtmlData, custom, ...other } = dataConfig;
Vue.prototype.$actConfig = {
	...custom,
	...other,
};

MtaH5.init({
	sid: '500685831', // 必填，统计用的appid
	cid: '500685832', // 如果开启自定义事件，此项目为必填，否则不填
	autoReport: 1, // 是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
	senseHash: 0, // hash锚点是否进入url统计
	senseQuery: 0, // url参数是否进入url统计
	performanceMonitor: 1, // 是否开启性能监控
	ignoreParams: [] // 开启url参数上报时，可忽略部分参数拼接上报
});

Vue.prototype.$mtaH5 = MtaH5;
window.MTA = MtaH5;
window.TAnalyticsfixedData = {
	dataid: 4000000000001,
	apiid: '00020002',
	isspa: 1,
	activityid: custom.uoActivityId,
	itemtype: 1001,
	pageid: 5001,
	sgameid: custom.gameId
};
Vue.prototype.isGeted = {
	h5: {},
	pc: {}
};
Vue.prototype.$TaAndMTA = (sData, MTAKey = '') => {
	TAnalytics(sData)
	if (MTAKey !== '') {
		MtaH5.clickStat(MTAKey)
	}
}
/* eslint-disable no-new */
window._Vue = new Vue({
	el: '#app',
	// router,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js